module.exports = __webpack_public_path__ + "static/bentonsans-regular-webfont-7ebbb23b2bdcddba643b27fe47068f27.woff2";